import { get, writable } from "svelte/store";
import tippy from "tippy.js";
import { _ } from "svelte-i18n";
export class ToolTip {
    Add(element, options) {
        if (typeof element === "undefined")
            return;
        const translation = get(_)(options.key);
        tippy(element, {
            content: translation,
            placement: options.placement ?? "top"
        });
        _.subscribe(formatter => {
            const translation = formatter(options.key);
            tippy(element, {
                content: translation,
                placement: options.placement ?? "top"
            });
        });
    }
    New(options) {
        const store = writable(undefined);
        store.subscribe(element => {
            toolTip.Add(element, options);
        });
        return store;
    }
}
export const toolTip = new ToolTip();
